// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pc-1";
export var messageSideRight = "_pc-2";
export var orderLookupBubbleContainer = "_pc-0";
export var submitButton = "_pc-3";